var React = window.React = require('react');
var ReactDOM = require('react-dom');

var secrets = require('../../src/constants/secrets.js');

window.app = {
  isEmbed: true
};

require('./styles/styles.less');

// some things should just work...
NodeList.prototype.forEach = Array.prototype.forEach;
HTMLCollection.prototype.indexOf = Array.prototype.indexOf;
HTMLCollection.prototype.forEach = Array.prototype.forEach;

// really simple version of object.assign
function assign(){
  var args = Array.prototype.splice.call(arguments, 0),
      target = args[0],
      srcs = args.slice(1);

  srcs.forEach(obj => {
    Object.keys(obj).forEach(key => {
      target[key] = obj[key];
    })
  });

  return target;
}

// Google Analytics tracking
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
ga('create', 'UA-38568098-2', 'auto');
ga('send', 'pageview');

// soundcloud api
SC.initialize({
  client_id: secrets.soundcloudKey
});

// Start App
var EmbedComponent = require('./components/EmbedComponent');
var page = require('page');
var routes = {};

routes.embed = function(ctx){
  var query = ctx.querystring.split('&').map(queryVar => {
    var split = queryVar.split('='), obj = {};
    obj[split[0]] = split[1] || true;
    return obj;
  }).reduce((memo, el) => {
    return assign(memo, el);
  }, {})

  let plId, v;
  if(ctx.params.v && !ctx.params.user){
    if(Number.isNaN(+ctx.params.v)){
      plId = ctx.params.id + '/' + ctx.params.v;
    } else {
      plId = ctx.params.id;
      v = ctx.params.v;
    }
  } else if(!ctx.params.v && !ctx.params.user){
    plId = ctx.params.id;
  } else {
    plId = ctx.params.user + '/' + ctx.params.id;
    v = ctx.params.v;
  }

  ReactDOM.render(<EmbedComponent playlistId={plId} party={query.party} version={v} />,
    document.querySelector('#gdj-embed'));
}

routes.notFound = function(){
  ReactDOM.render(<h1>embed - route not found</h1>,
    document.querySelector('#gdj-embed'));
}

page('/embed/:id/:v?', routes.embed);
page('/embed/:user/:id/:v?', routes.embed);
page('*', routes.notFound);
page();
